import React from 'react';
import {Input as AntInput} from 'antd';
import './styles.less';
const TextArea = (props) => {
    return (
        <AntInput.TextArea {...props} className={`hms-textarea ${props.className}`}/>
    )
}
export default TextArea;